export { MessengerPhotoModule } from './photo.module';
